import { formatCnpj } from "utils/federal-tax-id";
import { Box, Typography } from "@mui/material";
import { useStyles } from "./styles";

interface IOrganizationInfo {
  organizationName: string;
  organizationFederalTaxId: string;
}

const OrganizationInfo = ({
  organizationName,
  organizationFederalTaxId,
}: IOrganizationInfo) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography className={classes.organization}>
        {organizationName}
      </Typography>
      <Typography className={classes.federalTaxId}>
        {formatCnpj(organizationFederalTaxId)}
      </Typography>
    </Box>
  );
};

export default OrganizationInfo;
